export const OVERVIEW_GLOSSARY = [
  {
    key: 'overview.dau',
    label: 'DAU (média do período)',
    whatIs: 'DAU (Daily Active Users, ativos no dia) médio: média diária de pessoas diferentes que concluíram pelo menos uma ação de uso real (bater ponto, ajuste, aprovação, férias, espelho, documento) no período.',
    purpose: 'Resume o volume diário de uso do período num número só; a variação mostra se o uso diário cresceu ou caiu contra o período anterior de mesmo tamanho.',
    howGenerated: 'Média dos DAUs dos dias do período, cada um somado por dia local da empresa no fechamento diário (00:30, horário de Brasília), a partir dos eventos coletados a cada 15 minutos.',
    caveat: 'É média, não foto: WAU, MAU, empresas, Active Seats Rate e WAS ao lado são do último dia fechado do período.',
    metricKey: 'dau',
    seeAlso: ['engagement.dau'],
  },
  {
    key: 'overview.stickiness',
    label: 'Stickiness (DAU/MAU)',
    whatIs: 'Hábito de uso do período: média do DAU ÷ média do MAU × 100. 40% quer dizer que, em média, 4 de cada 10 ativos do mês usam num dia.',
    purpose: 'Mostra se o produto virou rotina; queda com MAU estável indica gente que usa menos vezes.',
    howGenerated: 'Razão das médias diárias de DAU e de MAU dos dias do período, ambas do fechamento diário. Por ser razão de médias, não traz numerador e denominador.',
    caveat: 'Não bate com o DAU/MAU de um ponto da série do Engajamento, que divide os números de um dia só.',
    metricKey: 'stickiness',
    seeAlso: ['engagement.stickiness'],
  },
  {
    key: 'overview.activation30d',
    label: 'Ativação em 30 dias',
    whatIs: 'Empresas vendidas que tiveram a primeira batida de ponto de um colaborador em até 30 dias da venda, entre as vendidas com essa janela já fechada.',
    purpose: 'Mede se a venda vira uso: queda indica implantação lenta e risco de cancelamento no começo do contrato.',
    howGenerated: 'Vendas (D0) dos 30 dias anteriores ao período, para que a janela de 30 dias já tenha fechado. Lido das janelas de ativação montadas toda noite a partir das vendas e das batidas.',
    caveat: 'Aceita só os cortes de porte e perfil da empresa. O clique leva à Ativação já filtrada por essas vendas.',
    metricKey: 'activation_rate_30d',
  },
  {
    key: 'overview.retentionW4',
    label: 'Retenção W4 (usuários)',
    whatIs: 'Parte das pessoas que começaram a usar numa semana e voltaram a agir até a 4ª semana seguinte, nas coortes semanais cuja 4ª semana terminou no período.',
    purpose: 'Mostra se quem começa a usar continua usando um mês depois.',
    howGenerated: 'Média ponderada das coortes semanais: retidos somados ÷ tamanhos somados × 100. As coortes são montadas toda noite (01:00, horário de Brasília) a partir da primeira ação de uso real de cada pessoa.',
    caveat: 'Não aceita filtro de empresa nem de corte. Coorte cuja 4ª semana ainda não fechou sai "Pendente".',
    metricKey: 'retention_user',
  },
  {
    key: 'overview.concentration',
    label: 'Concentração top 10 (MAU)',
    whatIs: 'Parte do MAU (ativos em 30 dias) que está nas 10 empresas com mais ativos, no último dia fechado do período.',
    purpose: 'Mede a dependência de poucos clientes: acima de 50% o PI abre um insight de concentração.',
    howGenerated: 'Soma do MAU das 10 maiores empresas ÷ MAU total × 100, do agregado por empresa na janela de 30 dias.',
    caveat: 'Quem está em duas das 10 empresas conta duas vezes no numerador (limitado a 100%). Com plataforma ou módulo, as 10 saem das 25 maiores, uma aproximação.',
    metricKey: 'top10_concentration',
    seeAlso: ['overview.concentrationShare'],
  },
  {
    key: 'overview.concentrationRank',
    label: 'Posição na concentração',
    whatIs: 'Posição da empresa entre as 10 com mais ativos em 30 dias (MAU) no recorte.',
    purpose: 'Mostra quais contas sustentam a maior parte do uso.',
    howGenerated: 'Ordem decrescente do MAU de cada empresa no último dia fechado do período, do agregado por empresa.',
  },
  {
    key: 'overview.concentrationShare',
    label: 'Participação no MAU',
    whatIs: 'MAU da empresa ÷ MAU total do recorte × 100, no último dia fechado do período.',
    purpose: 'Mostra quanto do uso de toda a base depende de cada uma das maiores contas.',
    howGenerated: 'Conta feita pela API com o MAU da empresa (agregado por empresa, janela de 30 dias) e o MAU total do mesmo dia.',
    seeAlso: ['overview.companyMau'],
  },
  {
    key: 'overview.companyMau',
    label: 'MAU da empresa (30 dias)',
    whatIs: 'Pessoas diferentes da empresa que concluíram pelo menos uma ação de uso real nos 30 dias até o último dia fechado do período.',
    purpose: 'É o tamanho do uso real da conta, a base da participação no MAU.',
    howGenerated: 'Do agregado por empresa na janela de 30 dias, calculado no fechamento diário a partir dos eventos de uso real.',
    seeAlso: ['common.activeUsers30d'],
  },
  {
    key: 'overview.operation',
    label: 'Operação',
    whatIs: 'Ação do produto acompanhada pelo PI, como gerar o espelho, reconhecimento facial na batida ou executar o relatório avançado.',
    purpose: 'Mostra se as operações que mais pesam para o cliente funcionam.',
    howGenerated: 'São as 5 primeiras operações do período: primeiro as que registram falha, depois as com mais tentativas. A lista completa está em Operações.',
  },
  {
    key: 'overview.operationSuccess',
    label: 'Sucesso da operação',
    whatIs: 'Tentativas distintas da operação que terminaram bem ÷ tentativas × 100 no período; repetir a mesma tentativa conta uma vez.',
    purpose: 'Queda no sucesso aponta problema técnico ou regra que recusa demais, antes do chamado do cliente.',
    howGenerated: 'Do agregado por hora (no horário universal, UTC) das tentativas de cada operação, cortado na meia-noite de Brasília. Recusa da regra e erro técnico contam como falha.',
    caveat: 'Só existe nas operações com falha registrada; nas demais sai n/d. Com menos de 30 tentativas sai "Dados insuficientes". Sem corte por empresa, papel, porte ou perfil.',
    metricKey: 'success_rate',
    seeAlso: ['overview.operationAttempts'],
  },
  {
    key: 'overview.operationSuccesses',
    label: 'Sucessos',
    whatIs: 'Tentativas distintas da operação que terminaram bem no período.',
    purpose: 'É o numerador da taxa de sucesso.',
    howGenerated: 'Soma do agregado por hora das tentativas com sucesso. Vem vazio quando a taxa não aparece na tela.',
  },
  {
    key: 'overview.operationAttempts',
    label: 'Tentativas',
    whatIs: 'Tentativas distintas da operação no período, com sucesso, recusa ou erro técnico.',
    purpose: 'É o denominador da taxa de sucesso e mostra o volume de uso da operação.',
    howGenerated: 'Soma do agregado por hora das tentativas, com a chave da tentativa para não contar repetição. Vem vazio quando a taxa não aparece na tela.',
  },
  {
    key: 'overview.operationState',
    label: 'Estado do sucesso',
    whatIs: 'Situação do número de sucesso: Medido, Parcial (período com dia não fechado), Dados insuficientes (menos de 30 tentativas) ou n/d (falha não registrada ou filtro sem corte).',
    purpose: 'Diz se a taxa pode ser lida como definitiva; o motivo aparece embaixo do selo.',
    howGenerated: 'Definido pela API a partir do fechamento dos dias, do número de tentativas e de a operação registrar falha ou não.',
    seeAlso: ['common.state.partial', 'common.state.insufficient', 'common.state.na'],
  },
  {
    key: 'overview.attention',
    label: 'Atenção agora',
    whatIs: 'Os 5 insights abertos mais recentes: avisos gerados por regras fixas sobre os agregados, como queda de adoção, ativação mais lenta ou concentração alta.',
    purpose: 'Aponta o que mudou e merece investigação. Nenhuma conclusão é automática: cada insight traz observação, hipótese e próxima investigação.',
    howGenerated: 'O job de insights roda todo dia às 02:07 (horário de Brasília) e só grava candidato com amostra mínima. O aviso vence em 7 dias (regras R) ou 7 dias após o fim da janela (padrões P).',
    caveat: 'A lista não segue o período escolhido: mostra os abertos mais recentes de qualquer data.',
  },
  {
    key: 'overview.insight',
    label: 'Insight',
    whatIs: 'Título do aviso gerado pela regra, com o assunto e o recorte afetado.',
    purpose: 'Identifica o que mudou e onde, para decidir se vale investigar.',
    howGenerated: 'Texto montado pelo job de insights a partir da regra que disparou e dos números do recorte.',
    seeAlso: ['overview.insightRule'],
  },
  {
    key: 'overview.insightStatus',
    label: 'Situação do insight',
    whatIs: 'Aberto (ninguém marcou como visto), Visto (alguém marcou) ou Expirado (passou da validade sem ser visto).',
    purpose: 'Separa o que ainda pede atenção do que já foi olhado.',
    howGenerated: 'Gravada no banco do PI: "Marcar como visto" grava quem viu e quando; o insight aberto vira expirado no dia seguinte ao vencimento.',
  },
  {
    key: 'overview.insightObservation',
    label: 'Observação',
    whatIs: 'O fato medido que disparou o insight, com os números do recorte e da base de comparação.',
    purpose: 'Mostra o que os dados dizem, sem interpretação.',
    howGenerated: 'Texto montado pelo job de insights com os valores atuais e de referência da regra.',
  },
  {
    key: 'overview.insightHypothesis',
    label: 'Hipótese',
    whatIs: 'Uma explicação possível para o fato observado, que ainda precisa ser conferida.',
    purpose: 'Dá um ponto de partida para a investigação; não é conclusão.',
    howGenerated: 'Texto fixo da regra, montado pelo job de insights; algumas regras só trazem hipótese em certos casos, e o campo pode vir vazio.',
  },
  {
    key: 'overview.insightNextStep',
    label: 'Próxima investigação',
    whatIs: 'O passo sugerido para confirmar ou descartar a hipótese, como abrir uma tela filtrada ou falar com a conta.',
    purpose: 'Transforma o aviso em ação concreta para quem lê.',
    howGenerated: 'Texto fixo de cada regra, montado pelo job de insights; o link "Abrir a visão filtrada" leva à tela indicada, já com o recorte do insight.',
  },
  {
    key: 'overview.insightRule',
    label: 'Regra do insight',
    whatIs: 'Código da regra que gerou o aviso: R1 a R9 (regras sobre os agregados, como queda de adoção ou de sucesso) e P1 a P4 (padrões de uso das funcionalidades).',
    purpose: 'Agrupa avisos do mesmo tipo e permite consultar o limiar e a amostra mínima de cada regra.',
    howGenerated: 'Cada regra tem limiar, amostra mínima e chave de ligar e desligar na configuração do PI; o mesmo assunto não volta no mesmo período.',
  },
  {
    key: 'overview.insightPeriod',
    label: 'Período do insight',
    whatIs: 'Início e fim do intervalo de dados que a regra avaliou para gerar o aviso.',
    purpose: 'Diz a que dias o fato observado se refere, que podem ser diferentes do período da tela.',
    howGenerated: 'Gravado pelo job de insights com a janela usada pela regra (por exemplo, os 30 dias da adoção ou a semana das operações).',
  },
  {
    key: 'overview.insightSample',
    label: 'Amostra do insight',
    whatIs: 'Tamanho da base avaliada pela regra, como elegíveis, tentativas, empresas ou usuários, conforme a regra.',
    purpose: 'Mostra o peso do aviso: amostra pequena pede mais cuidado ao concluir.',
    howGenerated: 'Contado pelo job de insights; só vira insight o candidato com amostra igual ou maior que a mínima da regra.',
    seeAlso: ['overview.insightConfidence'],
  },
  {
    key: 'overview.insightConfidence',
    label: 'Confiança do insight',
    whatIs: 'Alta, média ou baixa, conforme o tamanho da amostra em relação à mínima da regra.',
    purpose: 'Ajuda a priorizar: alta confiança é base maior, menos sujeita a acaso.',
    howGenerated: 'Alta com amostra de 5 vezes a mínima ou mais, média de 2 a 5 vezes e baixa abaixo disso.',
  },
  {
    key: 'overview.insightImpactedUsers',
    label: 'Usuários impactados',
    whatIs: 'Quantas pessoas estão no recorte afetado pelo fato observado, quando a regra mede pessoas.',
    purpose: 'Dimensiona o tamanho do problema ou da oportunidade.',
    howGenerated: 'Contado pelo job de insights no recorte e na janela da regra; vem vazio quando a regra não mede pessoas.',
  },
  {
    key: 'overview.insightImpactedCompanies',
    label: 'Empresas impactadas',
    whatIs: 'Quantas empresas estão no recorte afetado pelo fato observado, quando a regra mede empresas.',
    purpose: 'Dimensiona quantas contas o time de sucesso do cliente precisaria olhar.',
    howGenerated: 'Contado pelo job de insights no recorte e na janela da regra; vem vazio quando a regra não mede empresas.',
  },
  {
    key: 'overview.insightGeneratedAt',
    label: 'Insight gerado em',
    whatIs: 'Data e hora em que o job de insights gravou o aviso, em horário de Brasília.',
    purpose: 'Ordena os avisos e mostra quão recente é cada um.',
    howGenerated: 'Gravado pelo job de insights, que roda todo dia às 02:07 (horário de Brasília).',
  },
];



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/glossary/overview.js